import React from "react";
import { Form } from "react-bootstrap";

const PhoneNumberSection = (props) => {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          Mobile Number
          <Form.Control
            type="text"
            custom
            onChange={(value) =>
              props.setUser((prevUser) => ({
                ...prevUser,
                phoneNumber1: value.target.value,
                phoneNumber1Type: "Mobile",
              }))
            }
            style={{ width: "200px" }}
          />
        </div>
      </div>
      <div className="mt-3" style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ display: "flex", gap: "10px" }}>
          Add Secondary Phone Number
          <Form.Check
            type="switch"
            defaultChecked={props.addSecondNumber}
            onClick={() => props.setAddSecondNumber(!props.addSecondNumber)}
          />
        </div>
      </div>
      {props.addSecondNumber == true && (
        <div className="mt-3" style={{ display: "flex", flexDirection: "column" }}>
          Secondary Phone Number
          <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>
            <Form.Select
              custom
              onChange={(value) =>
                props.setUser((prevUser) => ({
                  ...prevUser,
                  phoneNumber2Type: value.target.value,
                }))
              }
              style={{ width: "100px" }}
            >
              <option>Mobile</option>
              <option>Office</option>
            </Form.Select>
            <Form.Control
              type="text"
              custom
              onChange={(value) =>
                props.setUser((prevUser) => ({
                  ...prevUser,
                  phoneNumber2: value.target.value,
                }))
              }
              style={{ width: "200px" }}
            />
            {props.user.phoneNumber2Type && props.user.phoneNumber2Type === "Office" && <span>EXT:</span>}
            {props.user.phoneNumber2Type && props.user.phoneNumber2Type === "Office" && (
              <Form.Control
                type="text"
                custom
                onChange={(value) =>
                  props.setUser((prevUser) => ({
                    ...prevUser,
                    phoneNumber2Ext: value.target.value,
                  }))
                }
                style={{ width: "100px" }}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PhoneNumberSection;
